import { render, staticRenderFns } from "./BusiformList.vue?vue&type=template&id=921669a0"
import script from "./BusiformList.vue?vue&type=script&lang=js"
export * from "./BusiformList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports